import { useDispatch } from 'react-redux';
import { closeModal } from './modalReducer';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField
} from '@mui/material';
import Transition from '../Transition/Transition';
import React, { useState } from 'react';
import { createTableView } from '../../store/actions';
import { updateTableView } from '../../store/actions/usersAction';

export default function TableViewSaveModal({
  viewId,
  viewName,
  tableViewTypeName,
  tableConfig,
  onSaved
}) {
  const dispatch = useDispatch();
  const [name, setName] = useState(viewName ?? '');

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  const handleConfirm = () => {
    const event = !viewId
      ? createTableView(tableViewTypeName, tableConfig, name)
      : updateTableView(viewId, name, tableConfig);

    dispatch(event)
      .then((result) => onSaved && onSaved(result))
      .then(() => dispatch(closeModal()));
  };

  const onNameChanged = (event) => setName(event.target.value);

  return (
    <Dialog open onClose={handleCloseModal} TransitionComponent={Transition} keepMounted>
      <Box bgcolor="#2C324D" p={2} display="flex" mb={2} color="white" alignItems="center">
        <DialogTitle id="alert-dialog-slide-title">Save Table view</DialogTitle>
      </Box>
      <DialogContent>
        <TextField
          fullWidth
          label="Name"
          variant="outlined"
          value={name}
          onChange={onNameChanged}
          id="table-view-name"
        />
      </DialogContent>
      <DialogActions>
        <Box p={2} display="flex" flexWrap="wrap">
          <Box ml={2} mr={2}>
            <Button onClick={handleCloseModal} color="secondary" variant="outlined">
              Cancel
            </Button>
          </Box>
          <Button
            onClick={handleConfirm}
            color="primary"
            variant="contained"
            disabled={name?.length === 0}
          >
            Confirm
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
}
